<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>New charge rate</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-storage-rate-form [rate]='this.rate'></app-storage-rate-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/storage-rates'>Cancel</button>
    </form>
  </div>
</div>
